// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__nZpBx","clinicsSelect":"TableHeading_clinicsSelect__116ri"};